import { DialogTitle } from "@mui/material";
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';



type DialogTitleClosableProps = {

    children?: React.ReactNode;
    onClose: () => void;

};


export const DialogTitleClosable: React.FC<DialogTitleClosableProps> = ( props: DialogTitleClosableProps ) => {

    const { children, onClose, ...other } = props;

    return(

        <DialogTitle sx={{ m: 0, p: 2 }} { ...other } >

            { children }
            { onClose ? (

                <IconButton
                    onClick={ onClose }
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon />
                </IconButton>

            ) : null }

        </DialogTitle>

    );

};